import usePrivateAxios from '@/common/api/usePrivateAxios';
import { ErrorResponse } from '@/common/types/errorResponse';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { MaintenanceEstablishmentChoiceAuctionEntryUpdatedSummaryData } from '../types/updatedSummary.type';

interface UseMaintenanceEstablishmentChoiceAuctionEntryUpdatedSummaryProps {
  auctionEntryId: string | undefined;
  options?: Partial<Omit<UseQueryOptions<
    { data: { data: MaintenanceEstablishmentChoiceAuctionEntryUpdatedSummaryData } },
    ErrorResponse,
    MaintenanceEstablishmentChoiceAuctionEntryUpdatedSummaryData
  >, 'queryKey' | 'queryFn'>>;
}

export const useMaintenanceEstablishmentChoiceAuctionEntryUpdatedSummary = ({
  auctionEntryId,
  options,
}: UseMaintenanceEstablishmentChoiceAuctionEntryUpdatedSummaryProps) => {
  const privateAxios = usePrivateAxios();

  return useQuery({
    enabled: !!auctionEntryId,
    queryKey: ['maintenanceEstablishmentChoiceAuctionEntryUpdatedSummary', auctionEntryId],
    queryFn: () => {
      return privateAxios.get(`/maintenance/establishment_choice/auction_entries/${auctionEntryId}/updated_summary`);
    },
    select: (response) => response?.data?.data,
    ...options
  });
}
